import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
const categories = [{
  id: 'all',
  name: 'All'
}, {
  id: 'braids',
  name: 'Braids'
}, {
  id: 'locs',
  name: 'Locs'
}, {
  id: 'twisted',
  name: 'Twisted Hair Styles'
}, {
  id: 'protective',
  name: 'Protective Hair Styles'
}];
const galleryItems = [{
  id: 1,
  title: 'Elegant Cornrows',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/oPcjCp9rNhyi11miaW2wZo/istockphoto-1618291225-612x612.webp'
}, {
  id: 2,
  title: 'Cornrow Braiding',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/2Rg35apmrhiBC7SirPQpSB/istockphoto-183341611-612x612.webp'
}, {
  id: 3,
  title: 'Box Braids with Beads',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/4HrN3tu5KNpG8RhMYChL1b/istockphoto-1352674262-612x612.webp'
}, {
  id: 4,
  title: 'Braided Updo',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/st4oeS41uakBMn5Py2Y32u/istockphoto-1333647263-612x612.webp'
}, {
  id: 5,
  title: 'Detailed Cornrows',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/mYcGRmj7PyBLcwuLLFXpAV/istockphoto-183332797-612x612.webp'
}, {
  id: 6,
  title: 'Braids with Design',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/aQStPq7UhC3dBDPkZSknxz/istockphoto-1256553670-612x612.jpg'
}, {
  id: 7,
  title: 'Side Braid Style',
  category: 'twisted',
  image: 'https://cdn.magicpatterns.com/uploads/tGErXKv5tYnexYUuxYDfJC/side-view-image-of-beautiful-braid-hair.jpg'
}, {
  id: 8,
  title: 'Micro Braids',
  category: 'protective',
  image: 'https://cdn.magicpatterns.com/uploads/8fkvPTEFH3AeLLB7R8gZQW/istockphoto-958683514-612x612.jpg'
}, {
  id: 9,
  title: 'Long Braids',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/vuTG195XiLqBgVUgSo55rG/istockphoto-1328500183-612x612.webp'
}, {
  id: 10,
  title: 'Faux Locs',
  category: 'locs',
  image: 'https://cdn.magicpatterns.com/uploads/87rXMcBwVohMSGNCqWzK4j/istockphoto-1312551586-612x612.webp'
}, {
  id: 11,
  title: 'Braiding in Progress',
  category: 'braids',
  image: 'https://cdn.magicpatterns.com/uploads/nGqjW7ZGQhk1ekNjuKRTGT/istockphoto-2254725453-612x612.jpg'
}, {
  id: 12,
  title: 'Locs Styling',
  category: 'locs',
  image: 'https://cdn.magicpatterns.com/uploads/9HJ51oQBNvS7NQJc6RsA29/istockphoto-1370569973-2048x2048.jpg'
}];
export function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const filteredItems = activeCategory === 'all' ? galleryItems : galleryItems.filter(item => item.category === activeCategory);
  return <>
      <PageBanner title="Style Gallery" subtitle="A glimpse into the artistry and precision of our master braiders" backgroundImage="https://cdn.magicpatterns.com/uploads/eo5z8xbijUvMyYUz4vBBDQ/ChatGPT_Image_Mar_10,_2026,_11_45_49_AM.png" data-id="element-482" />

      <section className="py-16 bg-white" data-id="element-483">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-484">
          {/* Category Filters */}
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-485">
            {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`px-5 py-2.5 rounded-sm text-sm font-medium transition-all duration-300 ${activeCategory === cat.id ? 'bg-burgundy text-white' : 'bg-gray-100 text-jet hover:bg-gray-200'}`} data-id="element-486">
                {cat.name}
              </button>)}
          </div>

          {/* Gallery Grid */}
          <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-487">
            <AnimatePresence mode="popLayout" data-id="element-488">
              {filteredItems.map((item, index) => <motion.div key={item.id} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.3,
              delay: index * 0.03
            }} className="relative aspect-[4/5] rounded-sm overflow-hidden group cursor-pointer" data-id="element-489">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-490" />

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-jet/80 via-jet/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-491"></div>

                  {/* Content */}
                  <div className="absolute inset-0 p-5 flex flex-col justify-end translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-492">
                    <div className="w-8 h-1 bg-golden mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-493"></div>
                    <h3 className="text-lg font-heading font-bold text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-150" data-id="element-494">
                      {item.title}
                    </h3>
                    <span className="text-golden/80 text-sm capitalize opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200" data-id="element-495">
                      {item.category === 'twisted' ? 'Twisted Hair Style' : item.category}
                    </span>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>

          {/* Instagram CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-16 text-center" data-id="element-496">
            <p className="text-jet/60 mb-4" data-id="element-497">
              See more of our work on social media
            </p>
            <div className="flex justify-center gap-4" data-id="element-498">
              <a href="https://www.instagram.com/benishairbraiding/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#F77737] text-white font-medium rounded-sm hover:opacity-90 transition-opacity" data-id="element-499">
                Follow on Instagram
              </a>
              <a href="https://www.tiktok.com/@benisbraids" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-jet text-white font-medium rounded-sm hover:bg-jet/80 transition-colors" data-id="element-500">
                Follow on TikTok
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </>;
}